/* eslint-disable no-shadow */

import Vue from 'vue';

const state = {
  admins: [],
};

const getters = {};

const mutations = {
  setAdmins(state, admins) {
    state.admins = admins;
  },
};

const actions = {
  fetchAdmins({ commit }) {
    return Vue.axios.get('admin/users')
      .then((response) => {
        commit('setAdmins', response.data.admin);
      })
      .catch();
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
